module.exports = "\n\n@import 'https://fonts.googleapis.com/icon?family=Material+Icons';\n/* You can add global styles to this file, and also import other style files */\n.md-sidenav-content {\n  background-color: #F0F0F0;\n}\nmd-input-container {\n  padding-bottom: 2px;\n  font-size: 16px;\n}\n.mat-select-trigger {\n  margin: 9px 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./apps/drift/src/styles.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./apps/drift/src/styles.css
// module chunks = styles